/* eslint-disable */
import Vue from 'vue';
import NwxSnackbar from './components/NwxSnackbar.vue';
import NwxPicklist from './components/NwxPicklist.vue';
import NwxPagination from './components/NwxPagination.vue';
import NwxCheckbox from './components/NwxCheckbox.vue';
import NwxAppSelect from './components/NwxAppSelect.vue';
import NwxAppPingCastleProductsSelect from './components/NwxAppPingCastleProductsSelect.vue';
import NwxAppProductsSelect from './components/NwxAppProductsSelect.vue';
import NwxSelect from './components/NwxSelect.vue';
import NwxComputersToProtectSelect from "./components/NwxComputersToProtectSelect.vue";
import NwxSwitcher from "@/components/NwxSwitcher.vue";
import NwxFileUploader from "@/components/NwxFileUploader.vue";

export default {
  install(Vue) {
    Vue.component(NwxSnackbar.name, NwxSnackbar);
    Vue.component(NwxPicklist.name, NwxPicklist);
    Vue.component(NwxPagination.name, NwxPagination);
    Vue.component(NwxCheckbox.name, NwxCheckbox);
    Vue.component(NwxSwitcher.name, NwxSwitcher);
    Vue.component(NwxFileUploader.name, NwxFileUploader);
    Vue.component(NwxAppSelect.name, NwxAppSelect);
    Vue.component(NwxAppPingCastleProductsSelect.name, NwxAppPingCastleProductsSelect);
    Vue.component(NwxAppProductsSelect.name, NwxAppProductsSelect);
    Vue.component(NwxSelect.name, NwxSelect);
    Vue.component(NwxComputersToProtectSelect.name, NwxComputersToProtectSelect);
  },
};
